// Centralized error logging utility. Can be swapped with a remote logger later.
export interface LoggedError {
  message: string;
  stack?: string;
  time: string; // ISO
  context?: Record<string, unknown>;
}

const buffer: LoggedError[] = [];

export function logError(err: unknown, context?: Record<string, unknown>) {
  const e = normalizeError(err);
  const entry: LoggedError = {
    message: e.message,
    stack: e.stack,
    time: new Date().toISOString(),
    context,
  };
  buffer.push(entry);
  if (buffer.length > 200) buffer.shift();
  // Access Vite env; fallback to true in unknown environments for visibility
  const dev = (import.meta as ImportMeta & { env?: { DEV?: boolean } }).env?.DEV ?? true;
  if (dev) {
    // eslint-disable-next-line no-console
    console.error('[AppError]', entry);
  }
  (window as unknown as { __errorBuffer?: LoggedError[] }).__errorBuffer = buffer;
}

export function getErrorBuffer() {
  return [...buffer];
}

function normalizeError(err: unknown): Error {
  if (err instanceof Error) return err;
  if (typeof err === 'string') return new Error(err);
  try {
    return new Error(JSON.stringify(err));
  } catch {
    return new Error('Unknown error');
  }
}
